export const APP_DEFAULT_PATH = '/dashboard/analytics';
export const HORIZONTAL_MAX_ITEM = 7;
export const DRAWER_WIDTH = 260;
export const MINI_DRAWER_WIDTH = 60;

export const ThemeMode = {
  LIGHT: 'light',
  DARK: 'dark',
};

export const ThemeDirection = {
  LTR: 'ltr',
  RTL: 'rtl',
};
export const MenuOrientation = {
  VERTICAL: 'vertical',
  HORIZONTAL: 'horizontal',
};

export const NavActionType = {
  FUNCTION: 'function',
  LINK: 'link',
};

const WebConfig = {
  APP_DEFAULT_PATH,
  HORIZONTAL_MAX_ITEM,
  DRAWER_WIDTH,
  MINI_DRAWER_WIDTH,
  ThemeMode,
  ThemeDirection,
  MenuOrientation,
  NavActionType,
};

export default WebConfig;
